class VideoBlock {
  constructor(dom) {
    this.NAME = 'VideoBlock';
    this.dom = dom;
    this.poster = dom.querySelector('[data-video-poster]');
    this.play = dom.querySelector('[data-video-play]');
    this.wrap = dom.querySelector('[data-video-wrap]');
    this.video = dom.querySelector('[data-video-element]');
    this.youtubeId = this.wrap ? this.wrap.dataset.youtubeId : null;
  }

  init() {
    if (!this.poster || !this.play || !this.wrap) return;
    if (!this.youtubeId && !this.video) return;

    this.play.addEventListener('click', () => {
      if (this.youtubeId) {
        this.playYoutube();
      } else {
        this.playFile();
      }
    }, { once: true });
  }

  playFile() {
    this.wrap.hidden = false;
    this.fadePoster();
    // A real <video> element needs an explicit play() call — un-hiding
    // it alone doesn't start playback.
    this.video.play();
  }

  // Lazy-loads the embed: the iframe doesn't exist until play is clicked,
  // so nothing is fetched from YouTube on page load. autoplay=1 works
  // (with sound) because the iframe is created inside the click handler.
  playYoutube() {
    const params = new URLSearchParams({
      autoplay: 1,
      playsinline: 1,
      rel: 0,
    });
    const iframe = document.createElement('iframe');
    iframe.className = 'video-block__iframe';
    iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(this.youtubeId)}?${params}`;
    iframe.title = this.wrap.dataset.youtubeTitle || 'YouTube video';
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    iframe.allowFullscreen = true;

    this.dom.classList.add('is-loading');
    this.wrap.hidden = false;
    this.wrap.appendChild(iframe);

    // Hold the poster until the player has loaded so the fade reveals the
    // video rather than an empty black box.
    iframe.addEventListener('load', () => {
      this.dom.classList.remove('is-loading');
      this.fadePoster();
    }, { once: true });
  }

  // Fades the poster out over the video wrap beneath it — the fade
  // itself lives in _video-block.scss (.video-block.is-playing).
  fadePoster() {
    this.dom.classList.add('is-playing');
  }
}

export default VideoBlock;
